import { render, staticRenderFns } from "./confirm-leave-upload.vue?vue&type=template&id=333dcbb0&scoped=true&"
import script from "./confirm-leave-upload.vue?vue&type=script&lang=js&"
export * from "./confirm-leave-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333dcbb0",
  null
  
)

export default component.exports